import {useEffect, useState} from 'react';
import AccountStore from 'src/stores/AccountStore';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import {getDescriber} from '../home/descriptors/campusComponents/DescriptorType';

const SendASnackView = () => {
  const [isSnackEnabled, setIsSnackEnabled] = useState(false);

  useEffect(() => {
    checkSendASnackStatus();
    FirebaseAnalytic.trackEvent('componentDidMount', 'SendSnackView');
    AccountStore.addChangeListener(checkSendASnackStatus);
    return () => {
      AccountStore.removeChangeListener(checkSendASnackStatus);
    };
  }, []);

  //Checks Send A Snack Status based on User and Home location settings
  const checkSendASnackStatus = () => {
    if (
      AccountStore.isConsumerSendSnackEnabled() &&
      AccountStore.isSendSnackEnabledForLocation()
    ) {
      setIsSnackEnabled(true);
    } else {
      setIsSnackEnabled(false);
    }
  };

  //Send a snack action
  const onSendASnackClick = () => {
    FirebaseAnalytic.trackEvent('onSendASnackClick', 'SendSnackView');
    NavActions.navigate(AppRoutes.SendSnack);
  };
  const describerprops = {
    onSendASnackClick,
  };

  return isSnackEnabled
    ? getDescriber().snackViewDescriptor(describerprops)
    : null;
};

export default SendASnackView;
